<template>
    <b-overlay :show="show" rounded="sm">
        <template #overlay>
            <div class="text-center">
                <div class="h2 mb-0">
                    <b-icon-watch
                        font-scale="3"
                        animation="cylon"
                    ></b-icon-watch>
                </div>
                <h2 class="text-dark">Procesando ....</h2>
            </div>
        </template>
        <div>
            <b-alert variant="primary" :show="show">
                <div class="alert-body">
                    <span> Acciones </span>
                </div>
            </b-alert>
            <b-card no-body :show="!show">
                <b-card-header
                    class="d-flex justify-content-between align-items-center pt-75 pb-25"
                >
                </b-card-header>

                <b-card-body>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="outline-secondary"
                        block
                        @click="
                            $router.push({
                                name: 'home',
                            })
                        "
                    >
                        Portal
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="primary"
                        block
                        v-b-modal.modal-paypal
                        hidden
                    >
                        Pagar
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="info"
                        block
                        v-b-modal.modal-contract-account
                    >
                        Estado de Cuenta
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="success"
                        block
                        @click="ot()"
                    >
                        Orden de Trabajo
                    </b-button>
                </b-card-body>
            </b-card>
        </div>
    </b-overlay>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCardHeader,
    BIconWatch,
    BOverlay,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ModalOt from "./modal/ModalOt.vue";

export default {
    directives: {
        Ripple,
    },
    components: {
        BCard,
        BCardHeader,
        BCardBody,
        BBadge,
        BButton,
        BAlert,
        BOverlay,
        BIconWatch,
        ToastificationContent,
        ModalOt,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("userData")),
            show: false,
            today: new Date(),
            show: true,
        };
    },
    created() {
        if (typeof this.data != "undefined") {
            this.show = false;
        }
    },
    methods: {
        ot() {
            this.$root.$emit("bv::show::modal", "modal-ot");
        },
        saveOt(op, cargo, fecha, nota) {
            this.$http
                .post("ot/", {
                    idcontrato: this.data.idcontrato,
                    idusuario: this.userData.id,
                    idottipo: op,
                    fecha: fecha,
                    idotestado: "PE",
                    nota_1: nota,
                    cargo: cargo,
                })
                .then((response) => {
                    let msn = response.data.msn;

                    this.show = false;

                    if (msn == "SI") {
                        this.$swal({
                            title: "OT Generada Correctamente",
                            text: "",
                            icon: "success",
                            customClass: {
                                confirmButton: "btn btn-primary",
                            },
                            buttonsStyling: false,
                        }).then((result) => {
                            if (result.value) {
                                this.$router.go();
                            }
                        });
                    } else {
                        const error = response.data.error;
                        this.$swal({
                            title: "Error",
                            text: error,
                            icon: "error",
                            customClass: {
                                confirmButton: "btn btn-danger",
                            },
                            buttonsStyling: false,
                        });
                    }
                })
                .catch(function (error) {
                    this.show = false;
                    this.showToast(error.message, "danger", "IconClose");
                    console.log(error);
                });
        },
        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant: variant,
                    icon: icon,
                },
            });
        },
    },
};
</script>

<style></style>
